import React, { Component } from 'react';
import classNames from 'classnames';
import DirectoryTree from './DirectoryTree';
import animation from '../_util/openAnimation';
import RcTree, { TreeNode } from '../rc-components/tree';
import { TreeNodeProps } from '../rc-components/tree/TreeNode';
import Icon from '../icon';
import Progress from '../progress';
import { ProgressType } from '../progress/enum';
import { Size } from '../_util/enum';
import { DataNode, EventDataNode } from '../rc-components/tree/interface';
import { isValidElement, cloneElement } from '../_util/reactNode';
import ConfigContext from '../config-provider/ConfigContext';
export { TreeNode };
export { EventDataNode, DataNode, TreeNodeProps };
export { ExpandAction as DirectoryTreeExpandAction, DirectoryTreeProps } from './DirectoryTree';
export default class Tree extends Component {
    constructor() {
        super(...arguments);
        this.renderSwitcherIcon = ({ isLeaf, loading }) => {
            const { showLine, switcherIcon } = this.props;
            const prefixCls = this.getPrefixCls();
            if (loading) {
                return (React.createElement(Progress, { type: ProgressType.loading, className: `${prefixCls}-switcher-loading-icon`, size: Size.small }));
            }
            const switcherCls = `${prefixCls}-switcher-icon`;
            let showLeafIcon;
            if (showLine && typeof showLine === 'object') {
                showLeafIcon = showLine.showLeafIcon;
            }
            if (isLeaf) {
                if (showLine) {
                    if (typeof showLine === 'object' && !showLeafIcon) {
                        return React.createElement("span", { className: `${prefixCls}-switcher-leaf-line` });
                    }
                    return React.createElement(Icon, { type: "note", className: `${prefixCls}-switcher-line-icon` });
                }
                return null;
            }
            if (isValidElement(switcherIcon)) {
                const switcherOriginCls = switcherIcon.props.className || '';
                return cloneElement(switcherIcon, {
                    className: [switcherOriginCls, switcherCls],
                });
            }
            return React.createElement(Icon, { type: "arrow_drop_down", className: switcherCls });
        };
        this.setTreeRef = (node) => {
            this.tree = node;
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    getPrefixCls() {
        const { prefixCls } = this.props;
        const { getPrefixCls } = this.context;
        return getPrefixCls('tree', prefixCls);
    }
    onKeyDown(e) {
        this.tree.onKeyDown(e);
        return e.isDefaultPrevented();
    }
    render() {
        const props = this.props;
        const { className, showIcon, showLine, children, checkable } = props;
        const prefixCls = this.getPrefixCls();
        const newProps = {
            ...props,
            showLine: Boolean(showLine),
        };
        return (React.createElement(RcTree, Object.assign({ itemHeight: 20, ref: this.setTreeRef }, newProps, { className: classNames(!showIcon && `${prefixCls}-icon-hide`, className), checkable: checkable ? React.createElement("span", { className: `${prefixCls}-checkbox-inner` }) : 0, switcherIcon: this.renderSwitcherIcon, prefixCls: prefixCls }), children));
    }
}
Tree.displayName = 'Tree';
Tree.TreeNode = TreeNode;
Tree.DirectoryTree = DirectoryTree;
Tree.defaultProps = {
    checkable: false,
    showIcon: false,
    openAnimation: animation,
};
